import { jsx as _jsx } from "react/jsx-runtime";
import { ActionTooltip } from '../ActionTooltip';
import { LinkStyled, TypographyStyled } from './CopyTypography.styled';
import { t } from '@/core/localization';
/**
 * Makes an inner text to become a link-like text with ability to copy the text to clipboard on link click.
 *
 * It also uses proper cursor ('default' by default) and allows it to be customized, disables user select and inherits
 * parent's fort size.
 */
const CopyTypography = ({ value, tooltip, tooltipPlacement, ...props }) => {
    const handleClick = () => {
        // Should not be used here since it blocks parent ActionTooltip's onClick event handler.
        // event.stopPropagation();
        copyToClipboard(props.children, value)();
    };
    if (tooltip)
        return (_jsx(ActionTooltip, { color: "success", title: t('copied.label'), closeDelay: 1200, placement: tooltipPlacement ?? 'auto', children: _jsx(LinkStyled, { color: props.color ? getLinkColorFromTypographyColor(props.color) : 'primary', fontWeight: props.fontWeight, className: props.className, enableUserSelect: props.enableUserSelect, wrap: props.wrap, onClick: handleClick, children: props.children }) }));
    return _jsx(TypographyStyled, { ...props, onClick: handleClick });
};
// TODO: (later) duplicate
function copyToClipboard(node, value) {
    return function () {
        if (value !== undefined) {
            navigator.clipboard.writeText(`${value}`);
            return;
        }
        if (!node || !(typeof node === 'string' || typeof node === 'number'))
            return;
        navigator.clipboard.writeText(`${node}`);
    };
}
/** MUI decided to have bugs with color prop for Typography and Link. Should be the same but they are different. (MUI v9.3.1) */
function getLinkColorFromTypographyColor(typographyColor) {
    switch (typographyColor) {
        case 'textPrimary': {
            return 'primary';
        }
        case 'textSecondary': {
            return 'secondary';
        }
        case 'textDisabled': {
            return 'disabled';
        }
        case 'textMedium': {
            return 'medium';
        }
        case 'textLight': {
            return 'light';
        }
        case 'textMuted': {
            return 'muted';
        }
        case 'textTranslucent': {
            return 'translucent';
        }
        default: {
            return typographyColor;
        }
    }
}
export { CopyTypography };
